// AUTO-GENERATED GraphQL Builder for Invoice
import * as Builders from '../';
export class InvoiceBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  guid(){ return this.add('guid'); }
  bookingId(){ return this.add('bookingId'); }
  invoiceNo(){ return this.add('invoiceNo'); }
  currentRevision(){ return this.add('currentRevision'); }
  totalAmount(){ return this.add('totalAmount'); }
  depositAmount(){ return this.add('depositAmount'); }
  balanceAmount(){ return this.add('balanceAmount'); }
  status(){ return this.add('status'); }
  issuedDate(){ return this.add('issuedDate'); }
  dueDate(){ return this.add('dueDate'); }
  id(){ return this.add('id'); }
  isDeleted(){ return this.add('isDeleted'); }
  createdBy(){ return this.add('createdBy'); }
  createdDate(){ return this.add('createdDate'); }
  updatedBy(){ return this.add('updatedBy'); }
  updatedDate(){ return this.add('updatedDate'); }

  booking(b?:(q:Builders.BookingBuilder)=>void){
    if(this.depth>=5||this.v.has('booking'))return this;
    this.v.add('booking');
    const n=new Builders.BookingBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`booking { ${inner} }`);
    return this;
  }

  createdByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('createdByUser'))return this;
    this.v.add('createdByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`createdByUser { ${inner} }`);
    return this;
  }

  updatedByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('updatedByUser'))return this;
    this.v.add('updatedByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`updatedByUser { ${inner} }`);
    return this;
  }

  invoiceRevisionList(b?:(q:Builders.InvoiceRevisionBuilder)=>void){
    if(this.depth>=5||this.v.has('invoiceRevisionList'))return this;
    this.v.add('invoiceRevisionList');
    const n=new Builders.InvoiceRevisionBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`invoiceRevisionList { ${inner} }`);
    return this;
  }

  ledgerEntryList(b?:(q:Builders.LedgerEntryBuilder)=>void){
    if(this.depth>=5||this.v.has('ledgerEntryList'))return this;
    this.v.add('ledgerEntryList');
    const n=new Builders.LedgerEntryBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`ledgerEntryList { ${inner} }`);
    return this;
  }

  paymentList(b?:(q:Builders.PaymentBuilder)=>void){
    if(this.depth>=5||this.v.has('paymentList'))return this;
    this.v.add('paymentList');
    const n=new Builders.PaymentBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`paymentList { ${inner} }`);
    return this;
  }

  reverseInvoiceRevision(b?:(q:Builders.InvoiceRevisionBuilder)=>void){
    const n=new Builders.InvoiceRevisionBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`invoiceRevisionList { ${inner} }`);
    return this;
  }

  reverseLedgerEntry(b?:(q:Builders.LedgerEntryBuilder)=>void){
    const n=new Builders.LedgerEntryBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`ledgerEntryList { ${inner} }`);
    return this;
  }

  reversePayment(b?:(q:Builders.PaymentBuilder)=>void){
    const n=new Builders.PaymentBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`paymentList { ${inner} }`);
    return this;
  }
}
